<template>
  <div :class="['test','phone-wrapper', { 'phone-wrapper-wa': isWA }, {'phone-wrapper-br': isBr}, {'phone-wrapper-error': phoneClassError && phoneNumError}]">
    <div class="code" @click="phoneFocus">{{ phoneCountryCode }}</div>
    <div class="input" @click="inputClick">
      <input
        ref="phone_input"
        autocomplete="off"
        type="tel"
        v-model="phoneNum"
        :placeholder="formItem.placeholder || $t('home.phonePlaceholder')"
        @keyup="handleKeyUp"
      />
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { emitFormUpdate } from "../../tools/utils";
import {
  ends,
  LOGIN_CONFIG,
  SUPPORT_COUNTRY as sc,
} from "../../tools/constant";

// 手机号基本格式
const REG_PHONE_NUM = /^\d+$/;

export default {
  props: ["formItem", "phoneClassError", "omegaItem"],
  data() {
    return {
      phoneNum: "",
      phoneNumValidate: false,
      phoneNumError: true,
    };
  },
  watch: {
    formItem: {
      handler(newV, oldV) {
        // this.phoneNum = newV.value
        this.formItem.value = this.phoneNum
      },
      deep: true,
      immediate: true, //页面初始化时立即调用
    },
    // 手机号红框动效曝光埋点
    phoneClassError(newV, oldV) {
      if(this.phoneClassError && this.phoneNumError) {
        this.reportPoints()
      }
    },
    phoneNumError(newV, oldV) {
      if(this.phoneClassError && this.phoneNumError) {
        this.reportPoints()
      }
    }
  },
  computed: {
    ...mapState(["_ticket", "_login_btn_text", "_phone_focus_global"]),
    isWA() {
      return this.formItem.style === 'whatsapp';
    },
    isBr() {
      return ["h5_br", "whatsapp_br", "h5_food"].includes(this.formItem.style);
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    phoneCountryCode() {
      return (
        LOGIN_CONFIG[this.location_country] ||
        window.didii18nconfig[this.location_country]
      ).country_calling_code;
    },
  },
  methods: {
    // 手机号输入框动效埋点
    reportPoints() {
      try{
        Omega.trackEvent("ibt_landingpage_phone_circle_sw", "", {
          oid: this.omegaItem.oid,
          location_country_code: this.omegaItem.country,
          channel: this.omegaItem.channel,
          end: this.omegaItem.end,
      });
      } catch(e) {

      }
    
    },
    phoneFocus() {
      this._phone_focus_global && this.$refs.phone_input.focus();
    },
    handleKeyUp() {
      this.validatePhoneNum();
    },
    validatePhoneNum() {
      this.phoneNumValidate = REG_PHONE_NUM.test(this.phoneNum);
      if (this.phoneNumValidate) {
        this.formItem.value = this.phoneNum
        this.phoneNumError = false;
      } else {
        this.formItem.value = ''
        this.phoneNumError = true;
      }
      emitFormUpdate(this, this.idx);
    },
    inputClick() {
      Omega.trackEvent("ibt_gd_whatsapp_phone_number_input_ck", "", {
        fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
        fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
      });
    }
  },
  components: {},
};
</script>
<style lang="scss" scoped>
@import "../../css/mixin.scss";
.phone-wrapper {
  padding: 0.34rem 0.4rem;
  display: flex;
  margin-bottom: 0.8rem;
  &:not(.phone-wrapper-wa):not(.phone-wrapper-br){
    @include border-1px(bottom);
    @include border-1px(top);
    .code {
      padding: 0.2rem;
      @include border-1px(right);
    }
  }
  &.phone-wrapper-br {
    align-items: center;
    margin: 0.32rem 0;
    background: rgba(145,160,180,0.15);
    border-radius: .12rem;
    .code {
      padding-right: 0.3rem;
      line-height: 150%;
      color: #91a0b4;
      border-right: 1px solid rgba(64,66,80,.3);
    }
    .code,
    .input {
      font-size: .36rem;
      font-weight: 400;
    }
  }
  &.phone-wrapper-wa {
    align-items: center;
    padding: 0.24rem;
    margin: 0 0.4rem 0.24rem 0.4rem;
    border: 0.02rem solid #dddddd;
    border-radius: 0.08rem;
    .code,
    .input {
      font-weight: 700;
    }
  }
  .input {
    flex: 1;
    padding-left: 0.34rem;
    input {
      font-size: 0.4rem;
      display: block;
      width: 100%;
      height: 100%;
      background: transparent;
    }
  }
}
.phone-wrapper-error {
  border: 1px solid red;
  animation: shake 800ms ease-in-out;
}
@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(+2px, 0, 0); }
  30%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(+4px, 0, 0); }
  50% { transform: translate3d(-4px, 0, 0); }
}
</style>


